import React, { useEffect } from "react";
import { Modal, Form, Input, Upload, Icon, Checkbox } from "antd";

const ModalFormComponent = ({
  visible,
  loading,
  data,
  onCancel,
  onCreate,
  form,
  fileList,
  handleImageChange,
  customRequest,
  handleRemove,
  handleImagePreviewModal
}) => {
  const { getFieldDecorator, setFieldsValue } = form;

  useEffect(() => {
    if (data) {
      setFieldsValue({
        name: data?.name,
        url: data?.url,
        isActive: data?.isActive !== undefined ? data.isActive : true
      });
    }
  }, [data, setFieldsValue]);

  return (
    <Modal
      visible={visible}
      title={data?._id ? "Edit Ad" : "Add Ad"}
      okText="Submit"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={onCreate}
    >
      <Form onSubmit={(e) => e.preventDefault()} layout="vertical">
        <Form.Item label="Ad Name">
          {getFieldDecorator("name", {
            rules: [{ required: true, message: "Ad name is required!" }]
          })(<Input placeholder="Enter ad name" />)}
        </Form.Item>

        <Form.Item label="Image">
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handleImagePreviewModal}
            customRequest={customRequest}
            onChange={handleImageChange}
            onRemove={handleRemove}
            accept="image/jpeg, image/png, image/webp"
          >
            {fileList.length >= 1 ? null : (
              <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
              </div>
            )}
          </Upload>
        </Form.Item>

        <Form.Item label="Target URL">
          {getFieldDecorator("url", {
            rules: [{ required: true, message: "URL is required!" }]
          })(<Input placeholder="Enter URL (with https://)" />)}
        </Form.Item>

        <Form.Item>
          {getFieldDecorator("isActive", {
            valuePropName: "checked",
            initialValue: true
          })(<Checkbox>Active</Checkbox>)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ModalForm = Form.create({ name: "ads_modal_form" })(ModalFormComponent);

export default ModalForm;
